import React, { useEffect } from "react";
import { useUsers } from "../context/UsersContext";
import UserList from "../components/FromUsers/UserList";
import Sidebar from "../components/Sidebar";
import HeaderPage from "../components/HeaderPage";

const TeachersPage = () => {
  const { teachers, fetchTeachers, loading } = useUsers();

  useEffect(() => {
    fetchTeachers();
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />
      {/* Contenido principal */}
      <div className="flex-1 bg-gray-100 p-6 overflow-y-auto">
      <div>
        <HeaderPage />
        </div>
        {loading ? (
          <p className="text-center text-xl font-semibold">Cargando profesores...</p>
        ) : (
          <UserList users={teachers} type="teachers" />
        )}
      </div>
    </div>
  );
};

export default TeachersPage;

